import React from 'react'
import Layout from "../../layout/layout";
import BrandVendorList from '../../wrapper/brand/BrandVendorList';
const BrandVendor = () => {
    return (
        <Layout>
            <BrandVendorList />
        </Layout>
    )
}

export default BrandVendor
